<script setup lang="ts">
  import { MpButton, MpDivider, MpText } from '@borg/ui';

  withDefaults(
    defineProps<{
      title?: string;
      preview?: boolean;
      showAddButton?: boolean;
      test?: string;
    }>(),
    {
      title: undefined,
      showAddButton: true,
      test: undefined,
    },
  );

  const emits = defineEmits<{
    (eventName: 'add'): void;
  }>();
</script>

<template>
  <div
    :class="{
      'my-profile-sub-section': true,
      'my-profile-sub-section--preview': preview,
    }"
  >
    <MpText
      v-if="title"
      as="h6"
      shade="50"
      class="my-profile-sub-section__title"
      no-margin
      uppercase
      style="margin-bottom: var(--mp-space-60)"
    >
      {{ title }}
    </MpText>
    <slot />
    <MpButton
      v-if="!preview && showAddButton"
      :text="$t('ADD')"
      variant="secondary"
      :test="`${test}-add-button`"
      left-icon="add"
      class="my-profile-sub-section__add-button"
      @click="emits('add')"
    />
    <MpDivider
      margin="lg"
      class="my-profile-sub-section__divider"
    />
  </div>
</template>

<style scoped lang="scss">
  .my-profile-sub-section {
    $self: &;

    &__title {
      page-break-after: avoid;
    }

    &__add-button {
      margin-top: var(--mp-space-60);
    }

    &--preview {
      border: 0;
      padding: 0;
    }

    &:last-of-type {
      #{$self}__divider {
        display: none;
      }
    }
  }
</style>
